/* eslint-disable no-labels */
import { toast } from 'react-hot-toast';
import { ApiEndpoints } from '../../services/endpoints';
import { apiService } from '../../services/service';

import * as prodTypes from '../actionTypes';
import { isNil, omitBy } from 'lodash';
import VendorMoqToast from 'components/Cart/VendorMoqToast';

export const get_product_stock = (data) => async (dispatch) => {
    try {
        dispatch({ type: prodTypes.GET_PRODUCT_STOCK });
        const response = await apiService.get(`/${ApiEndpoints.GET_PRODUCT_STOCK}?sku=${data}`);
        dispatch({ type: prodTypes.GET_PRODUCT_STOCK_SUCCESS, payload: response.data });
    } catch (error) {
        const message = error.response ? error.response.data.message : 'Something Went Wrong';
        dispatch({ type: prodTypes.GET_PRODUCT_STOCK_FAIL, payload: message });
    }
};

export const get_all_products = (queryParams) => async (dispatch) => {
    const params = {
        ...omitBy(
            {
                page: queryParams?.page || undefined,
                per_page: queryParams?.per_page || undefined,
                name: queryParams?.name || undefined,
                category: queryParams?.category || undefined,
                // sort_by: queryParams?.sort_by || undefined,
                price_sort: queryParams?.price_sort || undefined,
                vendor_name: queryParams?.vendor_name || undefined,
                brand: queryParams?.brand || undefined,
                stock_on_hand: queryParams?.stock_on_hand || undefined,
                // stock_on_hand: queryParams?.stock_on_hand || undefined,
                cf_sample_available: queryParams?.cf_sample_available || undefined,
            },
            isNil,
        ),
    };

    try {
        dispatch({ type: prodTypes.GET_PRODUCTS });
        const query = new URLSearchParams(params);
        const response = await apiService.get(`${ApiEndpoints.GET_PRODUCTS}?${query}`);
        if (response?.status === 'success') {
            dispatch({
                type: prodTypes.GET_PRODUCTS_SUCCESS,
                payload: response.data,
            });
        }
    } catch (error) {
        const message = error.response ? error.response.data.message : 'Something Went Wrong';

        dispatch({ type: prodTypes.GET_PRODUCTS_FAIL, payload: message });
    }
};

export const get_categories = () => async (dispatch) => {
    try {
        dispatch({ type: prodTypes.GET_CATEGORIES });
        const response = await apiService.get(`${ApiEndpoints.GET_CATEGORIES}?status=active`);
        if (response?.status === 'success') {
            dispatch({
                type: prodTypes.GET_CATEGORIES_SUCCESS,
                payload: response.data.categories,
            });
        }
    } catch (error) {
        const message = error.response ? error.response.data.message : 'Something Went Wrong';
        dispatch({ type: prodTypes.GET_CATEGORIES_FAIL, payload: message });
    }
};

export const get_brands = () => async (dispatch) => {
    dispatch({ type: prodTypes.LOADING_BRANDS, payload: true });
    try {
        const response = await apiService.get(`${ApiEndpoints.GET_BRANDS}?status=active`);
        if (response?.status === 'success') {
            dispatch({
                type: prodTypes.FETCH_BRANDS,
                payload: response.data.brands,
            });
        }
    } catch (error) {
        const message = error.response ? error.response.data.message : 'Something Went Wrong';
        dispatch({ type: prodTypes.GET_CATEGORIES_FAIL, payload: message });
    } finally {
        dispatch({ type: prodTypes.LOADING_BRANDS, payload: false });
    }
};

export const get_category_details = (id) => async (dispatch) => {
    try {
        dispatch({ type: prodTypes.GET_CATEGORY_DETAILS });
        const response = await apiService.get(
            `${ApiEndpoints.GET_CATEGORY_DETAILS}?category_id=${id}`,
        );
        if (response?.status === 'success') {
            dispatch({
                type: prodTypes.GET_CATEGORY_DETAILS_SUCCESS,
                payload: response.data.items,
            });
        }
    } catch (error) {
        const message = error.response ? error.response.data.message : 'Something Went Wrong';

        dispatch({ type: prodTypes.GET_CATEGORY_DETAILS_FAIL, payload: message });
    }
};
export const get_products_by_category = (id, hasSub, queryParams) => async (dispatch) => {
    if (id === 'null') return;
    let param = {
        category_id: id,
    };
    if (queryParams) {
        param = {
            ...omitBy({ ...param, ...queryParams }, isNil),
        };
    }
    const query = new URLSearchParams(param);
    try {
        dispatch({ type: prodTypes.GET_PRODUCTS_BY_CATEGORY });
        const response = await apiService.get(`${ApiEndpoints.GET_PRODUCTS}?${query}`);
        if (response?.status === 'success') {
            dispatch({
                type: prodTypes.GET_PRODUCTS_BY_CATEGORY_SUCCESS,
                payload: response.data,
            });
        }
    } catch (error) {
        const message = error.response ? error.response.data.message : 'Something Went Wrong';

        dispatch({ type: prodTypes.GET_PRODUCTS_BY_CATEGORY_FAIL, payload: message });
    }
};

export const create_cart =
    (data = '') =>
    async (dispatch) => {
        try {
            dispatch({ type: prodTypes.CREATE_CART });
            const response = await apiService.get(`${ApiEndpoints.CREATE_CART}`);

            if (response?.status === 'success') {
                if (response.data.quoteID && data.sku) {
                    data.quoteId = response.data.quoteID;
                    dispatch(add_to_cart(data));
                }
                dispatch({
                    type: prodTypes.CREATE_CART_SUCCESS,
                    payload: response.data.quoteID,
                });
            }
        } catch (error) {
            const message = error.response ? error.response.data.message : 'Something Went Wrong';

            dispatch({ type: prodTypes.CREATE_CART_FAIL, payload: message });
        }
    };

export const add_to_cart = (payload) => async (dispatch) => {
    try {
        toast.loading('Adding to cart...', { id: 'add-to-cart', position: 'top-right' });
        dispatch({ type: prodTypes.ADD_TO_CART });

        const response = await apiService.post({
            url: ApiEndpoints.ADD_TO_CART,
            payload,
        });

        const res = response.data;
        toast.dismiss('add-to-cart');

        if (res.message && !res.item_id) {
            dispatch({ type: prodTypes.ADD_TO_CART_FAIL, error: res.message });
            toast.error(res.message, { position: 'top-right' });
            return;
        }

        dispatch({ type: prodTypes.ADD_TO_CART_SUCCESS, payload: response.data });

        const addedItem = res?.items?.find((i) => i.item_id === payload.productId);
        const vendorSummary =
            addedItem && res?.vendor_summaries
                ? res.vendor_summaries.find((v) => v.vendor === addedItem.vendor) ?? null
                : null;

        if (addedItem) {
            toast.custom(
                (t) => (
                    <div style={{ marginTop: '10px' }}>
                        <VendorMoqToast
                            t={t}
                            item={addedItem}
                            vendorSummary={vendorSummary}
                            symbol="$"
                            convertedValues={null}
                        />
                    </div>
                ),
                {
                    id:'vendor-moq-toast',
                    duration: 2000,
                    position: 'top-right',
                },
            );
        }

        dispatch(view_cart());
    } catch (error) {
        toast.dismiss('add-to-cart');
        const message = error.response ? error.response.data.message : 'Network Error';
        dispatch({ type: prodTypes.ADD_TO_CART_FAIL, error: message });
        toast.error(message, { position: 'top-right' });
    }
};

export const checkout_cart = () => async (dispatch) => {
    try {
        dispatch({ type: prodTypes.CHECKOUT_CART });
        const response = await apiService.post({
            url: ApiEndpoints.CHECKOUT_CART,
            payload: {},
        });
        dispatch({
            type: prodTypes.CHECKOUT_CART_SUCCESS,
            payload: response.data,
        });
    } catch (error) {
        const data = error.response?.data;
        dispatch({
            type: prodTypes.CHECKOUT_CART_FAIL,
            payload: data,
        });
    }
};

export const update_cart_item = (payload) => async (dispatch) => {
    try {
        toast.loading('Updating cart item...', { position: 'top-right' });
        dispatch({ type: prodTypes.UPDATE_CART });
        const response = await apiService.put({
            url: ApiEndpoints.UPDATE_CART,
            payload,
        });

        const res = response.data;
        toast.dismiss();
        if (res.message && !res.item_id) {
            response.data.status = 'error';
            const message = res.message;
            dispatch({ type: prodTypes.UPDATE_CART_FAIL, error: message });
            toast.error(message, {
                position: 'top-right',
            });
        } else {
            dispatch({
                type: prodTypes.UPDATE_CART_SUCCESS,
                payload: response.data,
            });
            toast.success(' Added to cart', { position: 'top-right' });
            dispatch(view_cart(payload.quoteId));
        }
    } catch (error) {
        const message = error.response ? error.response.data.message : 'Network Error';
        dispatch({ type: prodTypes.UPDATE_CART_FAIL, error: message });
        toast.error(message, {
            position: 'top-right',
        });
    }
};

export const view_cart = () => async (dispatch) => {
    try {
        dispatch({ type: prodTypes.VIEW_CART_DETAILS });
        const response = await apiService.get(`${ApiEndpoints.VIEW_CART}`);
        if (response?.status === 'success') {
            dispatch({
                type: prodTypes.VIEW_CART_DETAILS_SUCCESS,
                payload: response.data,
            });
        }
    } catch (error) {
        const message = error.response ? error.response.data.message : 'Something Went Wrong';

        dispatch({ type: prodTypes.VIEW_CART_DETAILS_FAIL, payload: message });
    }
};

export const remove_from_cart = (data) => async (dispatch) => {
    try {
        dispatch({ type: prodTypes.REMOVE_FROM_CART });

        const response = await apiService.put({
            url: `${ApiEndpoints.REMOVE_FROM_CART}`,
            payload: data,
        });

        if (response?.status === 'success' && response.data) {
            dispatch({
                type: prodTypes.REMOVE_FROM_CART_SUCCESS,
                payload: data.data,
            });
            dispatch(view_cart());
        }
    } catch (error) {
        const message = error.response ? error.response.data.message : 'Something Went Wrong';
        toast.error(message, { position: 'top-right' });
        dispatch({ type: prodTypes.REMOVE_FROM_CART_FAIL, payload: message });
    }
};

export const add_shipping_details = (data) => async (dispatch) => {
    try {
        dispatch({ type: prodTypes.ADD_SHIPPING_DETAILS });
        const response = await apiService.post({
            url: `${ApiEndpoints.ADD_SHIPPING_DETAILS}?quoteID=${data.quoteId}`,
            payload: data,
        });

        dispatch({
            type: prodTypes.ADD_SHIPPING_DETAILS_SUCCESS,
            payload: response.data,
        });
    } catch (error) {
        const message = error.response ? error.response.data.message : 'Something Went Wrong';
        dispatch({ type: prodTypes.ADD_SHIPPING_DETAILS_FAIL, error: message });
        toast.error(message, {
            position: 'top-right',
        });
    }
};

export const get_shipping_details = (data) => async (dispatch) => {
    try {
        dispatch({ type: prodTypes.GET_SHIPPING_DETAILS });

        const response = await apiService.post({
            url: `${ApiEndpoints.GET_SHIPPING_DETAILS}?quoteID=${data}`,
            payload: data,
        });
        dispatch({
            type: prodTypes.GET_SHIPPING_DETAILS_SUCCESS,
            payload: response.data,
        });
    } catch (error) {
        const message = error.response ? error.response.data.message : 'Something Went Wrong';
        dispatch({ type: prodTypes.ADD_SHIPPING_DETAILS_FAIL, error: message });
        toast.error(message, {
            position: 'top-right',
        });
    }
};

export const add_billing_address = (data) => async (dispatch) => {
    try {
        dispatch({ type: prodTypes.ADD_BILLING_ADDRESS });

        const response = await apiService.post({
            url: `${ApiEndpoints.ADD_BILLING_ADDRESS}?quoteID=${data.quoteId}`,
            payload: data,
        });

        dispatch({ type: prodTypes.ADD_BILLING_ADDRESS_SUCCESS, payload: response.data });
    } catch (error) {
        const message = error.response ? error.response.data.message : 'Something Went Wrong';
        dispatch({ type: prodTypes.ADD_BILLING_ADDRESS_FAIL, error: message });
        toast.error(message, {
            position: 'top-right',
        });
    }
};

export const place_order = (data) => async (dispatch) => {
    try {
        dispatch({ type: prodTypes.PLACE_ORDER });
        const response = await apiService.post({
            url: `/${ApiEndpoints.PLACE_ORDER}?quoteID=${data.quoteId}`,
            payload: data.data,
        });
        if (response.data?.orderID !== undefined) {
            dispatch({
                type: prodTypes.CREATE_CART_SUCCESS,
                payload: null,
            });
        }
        dispatch({ type: prodTypes.PLACE_ORDER_SUCCESS, payload: response });
    } catch (error) {
        const message = error.response ? error.response.data.message : 'Cannot Place Order';
        dispatch({ type: prodTypes.PLACE_ORDER_FAIL, error: message });
    }
};

export const get_product_by_brand = (id, queryParams) => async (dispatch) => {
    dispatch({ type: prodTypes.LOADING_BRANDS, payload: true });
    try {
        const query = new URLSearchParams({
            brand: id,
            ...(queryParams || {}),
        });
        const response = await apiService.get(`${ApiEndpoints.GET_PRODUCTS}?${query}`);
        if (response?.status === 'success') {
            dispatch({
                type: prodTypes.FETCH_BRAND,
                payload: response.data,
            });
        }
    } catch (error) {
        const message = error.response ? error.response.data.message : 'Something Went Wrong';
        toast.error(message);
    } finally {
        dispatch({ type: prodTypes.LOADING_BRANDS, payload: false });
    }
};

export const get_product_by_vendor = (vendor_id, queryParams) => async (dispatch) => {
    dispatch({ type: prodTypes.LOADING_BRANDS, payload: true });
    try {
        const query = new URLSearchParams({
            vendor_id: vendor_id,
            ...(queryParams || {}),
        });
        const response = await apiService.get(`${ApiEndpoints.GET_PRODUCTS}?${query}`);
        if (response?.status === 'success') {
            dispatch({
                type: prodTypes.FETCH_BRAND,
                payload: response.data,
            });
        }
    } catch (error) {
        const message = error.response ? error.response.data.message : 'Something Went Wrong';
        toast.error(message);
    } finally {
        dispatch({ type: prodTypes.LOADING_BRANDS, payload: false });
    }
};

export const selectBrandAction = (brand) => (dispatch) => {
    dispatch({ type: prodTypes.SELECT_BRAND, payload: brand });
};
export const selectVendorAction = (brand) => (dispatch) => {
    dispatch({ type: prodTypes.SELECT_VENDOR, payload: brand });
};

export const getProductDetail = (data) => async (dispatch) => {
    dispatch({ type: prodTypes.LOADING_PRODUCT, payload: true });
    try {
        dispatch({ type: prodTypes.GET_PRODUCT });
        const response = await apiService.get(
            `${ApiEndpoints.GET_PRODUCT_DETAIL}?product_id=${data}`,
        );
        dispatch({ type: prodTypes.GET_PRODUCT, payload: response.data });
    } catch (error) {
        const message = error.response ? error.response.data.message : 'Something Went Wrong';
        toast.error(message);
    } finally {
        dispatch({ type: prodTypes.LOADING_PRODUCT, payload: false });
    }
};
